import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import ScrollToTop from './components/ScrollToTop';
import BookPopup from './components/BookPopup';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Homepage from './pages/Homepage';
import BookLanding from './pages/BookLanding';
import Spolupraca from './pages/Spolupraca';
import CorporateCooperation from './pages/CorporateCooperation';
import OMne from './pages/OMne';
import Vysledky from './pages/Vysledky';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Kontakt from './pages/Kontakt';
import Konzultace from './pages/Konzultace';
import Kariera from './pages/Kariera';
import GDPR from './pages/GDPR';
import Cookies from './pages/Cookies';
import BookThanks from './pages/BookThanks';
import BookOrder from './pages/BookOrder';
import Afrika from './pages/Afrika';
import PersonSchema from './components/PersonSchema';
import './App.css';

const AppContent = () => {
  const location = useLocation();
  const isKonzultace = location.pathname === '/konzultace';

  return (
    <div className="App min-h-screen flex flex-col overflow-x-clip">
      {!isKonzultace && <Navigation />}
      <main className="flex-grow min-w-0 overflow-x-clip">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/kniha" element={<BookLanding />} />
          <Route path="/spolupraca" element={<Spolupraca />} />
          <Route path="/firmy" element={<CorporateCooperation />} />
          <Route path="/o-mne" element={<OMne />} />
          <Route path="/afrika" element={<Afrika />} />
          <Route path="/vysledky" element={<Vysledky />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/kariera" element={<Kariera />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/konzultace" element={<Konzultace />} />
          <Route path="/gdpr" element={<GDPR />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/kniha/dekujeme" element={<BookThanks />} />
          <Route path="/kniha/objednavka" element={<BookOrder />} />
        </Routes>
      </main>
      {!isKonzultace && <Footer />}
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  return (
    <Router>
      <PersonSchema />
      <ScrollToTop />
      <BookPopup />
      <AppContent />
    </Router>
  );
}

export default App;